import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/browser';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import actions from 'api/actions';
import emailRegex from 'utils/emailRegex';

class LearningCenterContactModal extends Component {
  static propTypes = {
    open: PropTypes.bool,
    dismiss: PropTypes.func,
    learningCenterId: PropTypes.number.isRequired,
    instructorName: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);

    const { name, email, defaultMessage } = this.props;

    this.state = {
      name: name || '',
      email: email || '',
      message: defaultMessage || '',
      errors: {
        name: false,
        email: false,
        message: false,
      },
      success: false,
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  onSubmit(e) {
    e.preventDefault();
    const { learningCenterId } = this.props;
    const { name, email, message } = this.state;
    if (!message || !name || !emailRegex.test(email)) {
      this.setState({
        errors: {
          message: !message,
          name: !name,
          email: !emailRegex.test(email),
        },
      });
    } else {
      const data = { name, email, message };
      actions
        .post(`learning_centers/${learningCenterId}/contact`, data)
        .then(r => this.setState({ success: true }))
        .catch(e => Sentry.captureException(e));
    }
  }

  render() {
    const {
      dismiss,
      open,
      instructorName,
      name: parentName,
      email: parentEmail,
    } = this.props;
    const { name, email, message, errors, success } = this.state;
    return (
      <Modal isOpen={open} toggle={dismiss}>
        <ModalHeader toggle={dismiss}>Contact {instructorName}</ModalHeader>
        <ModalBody>
          {success ? (
            <div className="d-flex justify-content-center align-items-center w-100 h-100">
              <div className="d-flex flex-column justify-content-center align-items-center w-100 h-100">
                <h2>
                  Thank you for reaching out. {instructorName} will respond
                  soon!
                </h2>
              </div>
            </div>
          ) : (
            <form id="contact-instructor" onSubmit={this.onSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name*</label>
                <input
                  name="name"
                  id="name"
                  className="form-control"
                  onChange={this.onChange}
                  value={name}
                  disabled={parentName}
                />
                {errors.name && (
                  <p className="form-text text-red">Name is required.</p>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="email">Email*</label>
                <input
                  name="email"
                  id="email"
                  type="email"
                  className="form-control"
                  onChange={this.onChange}
                  value={email}
                  disabled={parentEmail}
                />
                {errors.email && (
                  <p className="form-text text-red">
                    Email is required and must be a valid email address.
                  </p>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="message">Message*</label>
                <textarea
                  name="message"
                  id="message"
                  className="form-control"
                  onChange={this.onChange}
                  value={message}
                  rows="5"
                />
                {errors.message && (
                  <p className="form-text text-red">Message is required.</p>
                )}
              </div>
            </form>
          )}
        </ModalBody>
        <ModalFooter>
          {success ? (
            <button type="button" onClick={dismiss} className="blue">
              Close
            </button>
          ) : (
            <React.Fragment>
              <button type="button" onClick={dismiss} className="outline red">
                Cancel
              </button>
              <button
                type="submit"
                form="contact-instructor"
                onClick={this.onSubmit}
                className="apple"
              >
                Submit
              </button>
            </React.Fragment>
          )}
        </ModalFooter>
      </Modal>
    );
  }
}

export default LearningCenterContactModal;
